import React, { useMemo } from "react";

import IframeModal from "~/pages/[brand]/iframe-modal/index.page";
import GlobalBrandStyle from "~/GlobalBrandStyle";
import { getLocalFont } from "../appUtils/fonts";
import { getBrandButtonFont, getBrandFont } from "~/cores/brandDataCore";

export default function IframeModalApp(props) {
    const { sharedAppProps } = props;
    const appProps = {
        ...sharedAppProps,
    };

    const { brandData } = appProps;
    const localFont = useMemo(() => {
        return getLocalFont(getBrandFont(appProps));
    }, [brandData]);

    const localButtonFont = useMemo(() => {
        return getLocalFont(getBrandButtonFont(appProps));
    }, [brandData]);

    return (
        <div>
            <GlobalBrandStyle
                appProps={appProps}
                {...brandData}
                color={brandData?.colorPrimary || "#343a40"}
                fontName={(localFont && `${localFont.style.fontFamily}`) || brandData?.fontNamePrimary}
                buttonFont={(localButtonFont && `${localButtonFont.style.fontFamily}`) || brandData?.buttonFont}
                fontSizeBody={brandData?.fontSizeBody || "14px"}
                fontWeightBody={brandData?.fontWeightBody || "normal"}
                uniformText={brandData?.uniformText || false}
            />
            <IframeModal appProps={appProps} />
        </div>
    );
}
